import axios from 'axios';
import { Formik } from 'formik';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const SignIn = () => {
  const navigate = useNavigate()
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white p-6 rounded-lg shadow-lg w-full h-full max-w-sm max-h-sm">
        <h1 className="text-3xl font-bold text-center mb-6">Sign In</h1>
        <Formik
          initialValues={{ userId: '', password: '' }}
          validate={(values) => {
            const errors = {};
            if (!values.userId) {
              errors.userId = 'Required';
            }
            if (!values.password) {
              errors.password = 'Required';
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting }) => {
            const loginCall = async (usr, pwd) => {
              return await axios.post(process.env.REACT_APP_LINKNET_URL + '/login', {
                username: usr,
                password: pwd,
              });
            };

            const completeCall = async (pui, code) => {
              return await axios.get(process.env.REACT_APP_LINKNET_URL + '/complete', {
                params: { partner_user_id: pui, code: code },
              });
            };

            try {
              const LoginResponse = await loginCall(values.userId, values.password);
              console.log("LoginResponse.data['preferedUsername'], LoginResponse.data['code'] : ", LoginResponse.data['preferedUsername'], LoginResponse.data['code'])
              if (LoginResponse.data !== null && (LoginResponse.data['code'] === '' || LoginResponse.data['preferedUsername'] === '')){
                throw new Error('Invalid Code');
              }else{
                // try{
                  const completeRes = await completeCall(LoginResponse.data['preferedUsername'], LoginResponse.data['code']);
                // }catch(error){
                //   console.error('Error:', error);
                //   if (error.response){
                //     console.log("error complete response.data: ", error.response.data);
                //     console.log("error complete response.status: ", error.response.status);
                //     console.log("error complete response.headers: ", error.response.headers);
                    
                //     // window.location.href = error.response.data['url'];
                //     // window.location.href = error.response.data['url'];
                  
                //   } else {
                //     // Something happened in setting up the request that triggered an Error
                //     console.log('Error', error.message);
                //   }    
                // }
              }
             
            } catch (error) {
              console.error('Error:', error);
            
              // Cek apakah error memiliki response dari server
              if (error.response) {
                console.log(error.response.data);
                console.log(error.response.status);
                console.log(error.response.headers);
                console.log("error.response.data['url']:",error.response.data['url'])
                // Pastikan error.response.data memiliki 'url' yang valid
                if (error.response.data['message'] && error.response.data['message'] !== '') {
                  const messageData = JSON.parse(error.response.data.message);

                  if (messageData.url) {
                    console.log("Redirecting to:", messageData.url); // Debugging output untuk cek URL
                    window.location.href = messageData.url; // Redirect ke URL yang ditemukan di response
                  } else {
                    navigate("/invalidcredential");
                  }
                } else {
                  // Redirect ke halaman invalid credential jika URL tidak ada
                  navigate("/invalidcredential");
                }
            
              } else if (error.message === 'Invalid Code') {
                // Jika pesan error adalah 'Invalid Code', redirect ke halaman not available
                console.log(error.request);
                navigate("/notavailable");
            
              } else {
                // Error lain yang mungkin terjadi, cetak pesan errornya
                console.log('Error', error.message);
              }
            
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label htmlFor="userId" className="sr-only">User ID</label>
                <input
                  type="text"
                  id="userId"
                  className="w-full p-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
                  name="userId"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.userId}
                  placeholder="User ID"
                />
                {errors.userId && touched.userId && <p className='text-sm text-red-600'>{errors.userId}</p>}
              </div>
              <div className="mb-4">
                <label htmlFor="password" className="sr-only">Password</label>
                <input
                  type="password"
                  id="password"
                  className="w-full p-3 border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600"
                  name="password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  placeholder="Password"
                />
                {errors.password && touched.password && <p className='text-sm text-red-600'>{errors.password}</p>}
              </div>
              <div className="flex items-center justify-between mb-6">
                <label className="inline-flex items-center">
                  <input
                    type="checkbox"
                    className="form-checkbox text-blue-600 focus:ring-blue-500 h-4 w-4"
                  />
                  <span className="ml-2 text-gray-700 text-sm">Remember me</span>
                </label>
                {/* <a href="#" className="text-sm text-blue-600 hover:underline">Forgot your info?</a> */}
              </div>
              <button
                type="submit"
                disabled={isSubmitting || !values.userId || !values.password}
                className={`w-full py-3 rounded-lg text-white font-semibold ${ isSubmitting || !values.userId || !values.password ? 'bg-gray-500' : 'bg-blue-500'}`}
              >
                Next
              </button>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default SignIn;